import React from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Typography, Grid, Box } from '@material-ui/core';

import EducationModal from './EducationModal';
import EducationCard from './EducationCard';
// import profile from '/static/images/png/profile.png'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      //   margin: theme.spacing(1),
      width: '120px',
      height: '120px'
    }
  },
  paper: {
    width: 'auto',
    height: 'auto',
    background: '#F1F4F8',
    padding: '10px'
  },
  align: {
    textAlign: 'end'
  },
  font: {
    fontSize: '18px',
    lineHeight: '21px'
  },
  font2: {
    fontSize: '14px'
  },
  AddEdu: {
    border: '2px dashed #1786D0',
    color: '#1786D0',
    textAlign: 'center',
    padding: '25px',
    borderRadius: '3px'
  },
  txtcolor: {
    opacity: '0.4',
    fontStyle: 'italic'
  }
}));

const DATA = {
  universityName: '',
  degree: '',
  major: '',
  gpa: '',
  description: '',
  startDate: '',
  endDate: ''
};

export default function Education() {
  const classes = useStyles();
  const educationSelector = useSelector(
    (state) => state.user.talentCard.education
  );

  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);

  const [data, setData] = React.useState({
    universityName: '',
    degree: '',
    major: '',
    gpa: '',
    description: '',
    startDate: '',
    endDate: ''
  });
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setData(DATA);
    setEdit(false);
  };

  const onEdit = (data) => {
    setData(data);
    setEdit(true);
    handleOpen();
  };

  console.log('Education list', educationSelector, data);

  return (
    <div>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography color="primary" className={classes.txtcolor}>
              Education
            </Typography>
          </Grid>
          {/* <Grid item xs={6} className={classes.align}></Grid> */}
          {/* <div style={{ overflowY: 'hidden auto', padding: '8px' }}> */}
          <Box
            sx={{
              maxHeight: '205px',
              width: '100%',
              overflowY: 'auto',
              overflowX: 'hidden',
              padding: '0px 8px'
            }}
          >
            {/* <Grid container> */}
            {!educationSelector.length ? (
              <Typography color="primary" variant="subtitle1">
                No data found
              </Typography>
            ) : (
              educationSelector.map((education) => (
                <Grid item xs={12} key={education._id}>
                  <EducationCard education={education} onEdit={onEdit} />
                </Grid>
              ))
            )}
            {/* </Grid> */}
            {/* </div> */}
            <br />
          </Box>
          {/* <br /> */}
          <Box sx={{ width: '100%', padding: '8px' }}>
            <EducationModal
              open={open}
              handleOpen={handleOpen}
              handleClose={handleClose}
              data={data}
              isEdit={edit}
            />
          </Box>
        </Grid>
      </div>
    </div>
  );
}
